// import { useNavigate, useParams } from "react-router-dom";
// import { useEffect, useState } from "react";
// import "./ReturnReplace.scss";
// import HeaderOne from "../../../HeaderOne";
// import Breadcrumb from "../../../Breadcrumb";
// import FooterOne from "../../../FooterOne";
// import Swal from "sweetalert2";

// const ReturnReplace = () => {
//   const { orderId } = useParams();

//   const [reason, setReason] = useState("");
//   const [returnType, setReturnType] = useState("refund");
//   const [comment, setComment] = useState("");
//   const [image, setImage] = useState(null);
//   const [errors, setErrors] = useState({});
//   const navigate = useNavigate();

//   // Swal Toast 
//   const Toast = Swal.mixin({
//     toast: true,
//     position: "bottom-end",
//     timer: 2000,
//     showConfirmButton: false,
//   });

//   const errorStyle = {
//     border: "1px solid #e53935",
//     backgroundColor: "#ffeaea"
//   };

//   const handleImageUpload = (e) => {
//     setImage(e.target.files[0]);
//   };

//   // ---------------- VALIDATION ----------------
//   const validate = () => {
//     let temp = {};

//     if (!reason.trim()) temp.reason = "Please select a reason";
//     if (returnType === "") temp.returnType = "Select refund or replacement";
//     if (comment.trim().length < 5) temp.comment = "Comment must be at least 5 characters";

//     setErrors(temp);
//     return Object.keys(temp).length === 0;
//   };

//   const handleSubmit = () => {
//     if (!validate()) {
//       Toast.fire({ icon: "error", title: "Please fix the highlighted fields." });
//       return;
//     }

//     Swal.fire({
//       icon: "success",
//       title: "Return Request Submitted!",
//       text: "Our team will review your request soon.",
//       confirmButtonColor: "#3085d6",
//     }).then(() => {
//       // Redirect example (if needed):
//       // window.location.href = "/user/orders";
//       navigate("/user/orders");
//     });
//   };

//   return (
//     <>
//     <HeaderOne/>
//     <Breadcrumb/>
//     <div className="return-container">

//       <h2 className="return-header">Return / Replace Request</h2>
//       <p className="return-order-id">Order #{orderId}</p>

//       <div className="return-section">
//         <h3>Reason for Return</h3>
//         <select
//           value={reason}
//           onChange={(e) => setReason(e.target.value)}
//           className="return-select"
//         >
//           <option value="">Select a reason</option>
//           <option value="damaged">Item damaged</option>
//           <option value="wrong">Wrong item delivered</option>
//           <option value="quality">Poor quality</option>
//           <option value="not-needed">No longer needed</option>
//           <option value="other">Other</option>
//         </select>
//       </div>

//       <div className="return-section">
//         <h3>Return Type</h3>
//         <div className="radio-group">
//           <label>
//             <input
//               type="radio"
//               checked={returnType === "refund"}
//               onChange={() => setReturnType("refund")}
//             />
//             Refund
//           </label>

//           <label>
//             <input
//               type="radio"
//               checked={returnType === "replace"}
//               onChange={() => setReturnType("replace")}
//             />
//             Replacement
//           </label>
//         </div>
//       </div>

//       <div className="return-section">
//         <h3>Upload Image (optional)</h3>
//         <input type="file" onChange={handleImageUpload} className="file-input" />

//         {image && <p className="file-name">Selected: {image.name}</p>}
//       </div>

//       <div className="return-section">
//         <h3>Additional Comments</h3>
//         <textarea
//           className="return-textarea"
//           style={errors.comment ? errorStyle : {}}
//           placeholder="Describe your issue..."
//           value={comment}
//           onChange={(e) => setComment(e.target.value)}
//         />
//       </div>

//       <button className="submit-return-btn" onClick={handleSubmit}>
//         Submit Return Request
//       </button>
//     </div>
//     <FooterOne/>
//     </>
//   );
// };

// export default ReturnReplace;

import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import "./ReturnReplace.scss";
import HeaderOne from "../../../HeaderOne";
import Breadcrumb from "../../../Breadcrumb";
import FooterOne from "../../../FooterOne";
import Swal from "sweetalert2";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const CancelOrder = () => {
  const { orderId } = useParams();

  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");

  const navigate = useNavigate();

  const token = localStorage.getItem("authToken");

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    timer: 2000,
    showConfirmButton: false,
  });

  const errorStyle = {
    border: "1px solid #e53935",
    backgroundColor: "#ffeaea",
  };

  const [errors, setErrors] = useState({});

  const validate = () => {
    const temp = {};

    if (!reason.trim()) {
      temp.reason = "Please select a reason";
    }

    setErrors(temp);

    return Object.keys(temp).length === 0;
  };

  const handleCancelOrder = async () => {
    if (!validate()) {
      Toast.fire({
        icon: "error",
        title: "Please select a reason",
      });
      return;
    }

    const confirm = await Swal.fire({
      title: "Cancel Order?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Cancel Order",
      cancelButtonText: "No",
    });

    if (!confirm.isConfirmed) return;

    try {
      const res = await axios.put(
        `${API_URL}/order/cancel/${orderId}`,
        {
          reason,
          comment,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data.success) {
        Swal.fire({
          icon: "success",
          title: "Order Cancelled",
          text: "Your order has been cancelled successfully.",
        }).then(() => {
          navigate("/user/orders");
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Cancellation Failed",
        text:
          error?.response?.data?.message ||
          "Unable to cancel order",
      });
    }
  };

  return (
    <>
      <HeaderOne />
      <Breadcrumb />

      <div className="return-container mt-10">
        <h2 className="return-header">
          Cancel Order
        </h2>

        <p className="return-order-id">
          Order #{orderId}
        </p>

        <div className="return-section">
          <h3>Reason for Cancellation</h3>

          <select
            value={reason}
            onChange={(e) =>
              setReason(e.target.value)
            }
            className="return-select"
            style={
              errors.reason
                ? errorStyle
                : {}
            }
          >
            <option value="">
              Select a reason
            </option>

            <option value="ordered-by-mistake">
              Ordered by mistake
            </option>

            <option value="found-better-price">
              Found a better price
            </option>

            <option value="delivery-delay">
              Delivery taking too long
            </option>

            <option value="changed-mind">
              Changed my mind
            </option>

            <option value="duplicate-order">
              Duplicate order
            </option>

            <option value="other">
              Other
            </option>
          </select>
        </div>

        <div className="return-section">
          <h3>
            Additional Comments
            (Optional)
          </h3>

          <textarea
            className="return-textarea"
            placeholder="Add any comments..."
            value={comment}
            onChange={(e) =>
              setComment(e.target.value)
            }
          />
        </div>

        <button
          className="submit-return-btn"
          onClick={handleCancelOrder}
        >
          Cancel Order
        </button>
      </div>

      <FooterOne />
    </>
  );
};

export default CancelOrder;